export default {
	"order.TheProductYouPurchasedCannotBeActivatedTemporarilyYouCanLogInToTheCallAppToManuallyActivateItOrContactCustomerServiceForHelp": "The product you purchased cannot be activated temporarily. You can log in to the [Call] App to manually activate it or contact customer service for help",
	"order.yourPurchases": "your purchases",
	"order.ItHasBeenActivatedPleaseEnterTheCallAppAsSoonAsPossibleToExperience": "It has been activated, please enter the [Call] App as soon as possible to experience",
	"order.ParameterError": "Parameter error!",
	"order.courseIsActive": "course is active",
	"order.youHavePurchased": "you have purchased",
	"order.Product": "Product"
}